<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <card>
          <VehicleDeviationReportFormVue></VehicleDeviationReportFormVue>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VehicleDeviationReportFormVue from '@/components/Report2/VehicleDeviationReportForm.vue'

export default {
  name: 'VehicleDeviationReport',
  components: {
    VehicleDeviationReportFormVue,
  },
}
</script>
